import React, { useState } from "react";
import CheckoutProductsModal from "./CheckoutProductsModal";

export default function CheckoutProductList() {
    const [open, setOpen] = useState(false);

    return (
        <>
            {/* ==== PHẦN DANH SÁCH RÚT GỌN ==== */}
            <section
                className="MuiPaper-root styles_root__o8ek_ MuiPaper-elevation0 MuiPaper-rounded"
                id="checkout-product-list"
            >
                <div className="MuiBox-root css-1qm1lh">
                    <h2 className="styles_title__Y0M1E">
                        Danh sách sản phẩm (Số lượng: 7)
                    </h2>
                </div>

                <div className="MuiTableContainer-root">
                    <table className="MuiTable-root styles_cartItemsTable__HT5Rb">
                        <tbody className="MuiTableBody-root">

                            {/* Seller header */}
                            <tr className="MuiTableRow-root styles_noBorder__bNo5B">
                                <td
                                    className="MuiTableCell-root MuiTableCell-body MuiTableCell-sizeSmall"
                                    colSpan={100}
                                >
                                    <div className="MuiBox-root css-j0ozid">

                                        <div className="styles_sellerImage___lZqP">
                                            <span style={{
                                                boxSizing: "border-box",
                                                display: "inline-block",
                                                overflow: "hidden",
                                                width: "initial",
                                                height: "initial",
                                                position: "relative",
                                                maxWidth: "100%",
                                            }}>
                                                <span style={{ display: "block" }}>
                                                    <img
                                                        alt=""
                                                        aria-hidden="true"
                                                        src="data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='28' height='28'/%3e"
                                                        style={{ display: "block" }}
                                                    />
                                                </span>

                                                <img
                                                    alt="Opella (Sanofi) Việt Nam"
                                                    src="https://gcs.buymed.com/thuocsi-live/images/2025447e390b5b3a59b835ab89468ae0?quality=100"
                                                    style={{
                                                        position: "absolute",
                                                        inset: 0,
                                                        margin: "auto",
                                                        display: "block",
                                                        minWidth: "100%",
                                                        minHeight: "100%",
                                                        maxWidth: "100%",
                                                        maxHeight: "100%"
                                                    }}
                                                />
                                            </span>
                                        </div>

                                        <div className="styles_sellerName__PC1wP MuiBox-root css-i9gxme">
                                            Opella (Sanofi) Việt Nam
                                        </div>

                                        <div className="styles_header__UfJLh MuiBox-root css-epvm6">
                                            1 sản phẩm
                                        </div>
                                    </div>
                                </td>
                            </tr>

                            {/* table header */}
                            <tr className="MuiTableRow-root styles_dashBorder__uLpxz">
                                <td className="MuiTableCell-root MuiTableCell-body styles_header__UfJLh MuiTableCell-sizeSmall" width="50%">
                                    Sản phẩm
                                </td>
                                <td className="MuiTableCell-root MuiTableCell-body styles_header__UfJLh MuiTableCell-alignCenter MuiTableCell-sizeSmall">
                                    SL đặt
                                </td>
                                <td className="MuiTableCell-root MuiTableCell-body styles_header__UfJLh MuiTableCell-alignRight MuiTableCell-sizeSmall">
                                    Giá mua (đ)
                                </td>
                                <td className="MuiTableCell-root MuiTableCell-body styles_header__UfJLh MuiTableCell-alignRight MuiTableCell-sizeSmall">
                                    Tổng cộng (đ)
                                </td>
                            </tr>

                            {/* 1 product row */}
                            <tr className="MuiTableRow-root styles_lastBorder__U_ghb">
                                <td className="MuiTableCell-root MuiTableCell-body MuiTableCell-sizeSmall">
                                    <div className="MuiBox-root css-j0ozid">

                                        <div className="styles_productImage__7FaA6">
                                            <span style={{ position: "relative", display: "inline-block" }}>
                                                <span>
                                                    <img
                                                        alt=""
                                                        aria-hidden="true"
                                                        src="data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100'/%3e"
                                                    />
                                                </span>

                                                <img
                                                    alt="Combo 160 Magne B6"
                                                    src="https://gcs.buymed.com/thuocsi-live/images/2024d52b50ff9f68cb3e2363bca5787b?quality=100"
                                                    style={{
                                                        position: "absolute",
                                                        inset: 0,
                                                        margin: "auto",
                                                        objectFit: "contain",
                                                        minWidth: "100%",
                                                        minHeight: "100%"
                                                    }}
                                                />
                                            </span>
                                        </div>

                                        <div className="styles_productName__FVRI6">
                                            Combo 160 Magne B6 Corbiere Sanofi (hộp/50 viên nén)
                                        </div>
                                    </div>
                                </td>

                                <td className="MuiTableCell-root MuiTableCell-body styles_header__UfJLh MuiTableCell-alignCenter MuiTableCell-sizeSmall">
                                    4
                                </td>

                                <td className="MuiTableCell-root MuiTableCell-body MuiTableCell-sizeSmall">
                                    <div className="styles_flex_no_wrap__1vvft styles_justifyContentEnd__yd1n7 MuiBox-root css-0">
                                        <div className="styles_canvasPrice__vw932 MuiTableCell-alignRight text-[#005c29] text-[16px]" style={{ height: 25 }}> 12.918.000đ</div>
                                    </div>
                                </td>

                                <td className="MuiTableCell-root MuiTableCell-body MuiTableCell-sizeSmall">
                                    <div className="styles_flex_no_wrap__1vvft styles_justifyContentEnd__yd1n7 MuiBox-root css-0">
                                        <div className="styles_canvasPrice__vw932 text-[#005c29] text-[16px]" style={{ height: 25 }}>62.918.000đ</div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* BUTTON XEM TẤT CẢ */}
                <div
                    className="styles_seeAll__ilpDo MuiBox-root css-qq9c22"
                    tabIndex={0}
                    onClick={() => setOpen(true)}
                >
                    Xem tất cả
                </div>
            </section>

            {/* ==== POPUP DANH SÁCH ĐẦY ĐỦ ==== */}
            {open && (
                <CheckoutProductsModal
                    open={open}
                    onClose={() => setOpen(false)}
                />
            )}
        </>
    );
}
